import styled from 'styled-components';

export const HeaderContainer = styled.div`
  @media (min-width: 266px) and (max-width: 700px) {
    margin-top: 28px;
  }
`;

export const Content1 = styled.div`
  & {
    width: 9px;
    height: 9px;
    position: relative;
    background: repeating-linear-gradient(-45deg, #e5e3e3, #e5e3e3 2.5px, white 2.5px, white 5px);
    margin-left: 3px;
  }
  &:after {
    content: '';
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    border: #e5e3e4 1px solid;
  }
`;

export const Content2 = styled.div`
  & {
    width: 9px;
    height: 9px;
    position: relative;
    background: #ffbc3d;
    margin-left: 3px;
  }
  &:after {
    content: '';
    position: absolute;
    top: -3px;
    left: -3px;
    right: -3px;
    bottom: -3px;
    border: #e5e3e4 1px solid;
  }
`;

export const GraphDetailsSpan = styled.span`
  font-size: 10px;
  position: absolute;
  padding-top: 2px;
  margin-left: 9px;
`;

export const Graph = styled.table`
  margin-bottom: 2em;

  & tbody th {
    text-align: right;
  }

  @supports (display: grid) {
    @media (min-width: 15em) {
      display: block;
      width: 100%;
      height: 155px;

      & caption {
        display: block;
      }

      & thead {
        display: none;
      }

      & tbody {
        position: relative;
        display: grid;
        grid-template-columns: repeat(auto-fit, minmax(2em, 1fr));
        column-gap: 2.5%;
        align-items: end;
        height: 100%;
        margin-top: 2.5em;
        border-bottom: 1px solid rgba(0, 0, 0, 0.5);
      }

      & tbody:before,
      & tbody:after {
        position: absolute;
        left: -3.2em;
        width: 2.8em;
        text-align: right;
      }

      & tr {
        position: relative;
        display: block;
        width: 85%;
      }

      & tr:hover {
        z-index: 999;
      }

      & th,
      & td {
        display: block;
        text-align: center;
      }

      & tbody th {
        position: absolute;
        top: -1.7em;
        left: 0;
        width: 100%;
        font-weight: bold;
        text-align: center;
        white-space: nowrap;
        text-indent: 0;
      }

      & tbody th:after {
        content: '';
      }

      & td {
        width: 100%;
        height: 100%;
        position: relative;
        bottom: -3.5em;
        display: flex;
        justify-content: center;
        align-items: flex-end;
        font-weight: bold;
        font-size: 9px;
      }

      .bar1 {
        background: repeating-linear-gradient(-45deg, #e4e5e3, #e4e5e3 5px, white 5px, white 10px);
        max-height: 150px;
        margin-bottom: 0.2px;
      }

      .bar2 {
        max-height: 150px;
        margin-bottom: 0.2px;
      }
    } /* min-width:32em */
  }
`;

export const VisuallyHiddenSpan = styled.span`
  border: 0;
  padding: 0;
  margin: 0;
  position: absolute !important;
  height: 1px;
  width: 1px;
  overflow: hidden;
  clip: rect(1px 1px 1px 1px); /* IE6, IE7 - a 0 height clip, off to the bottom right of the visible 1px box */
  clip: rect(1px, 1px, 1px, 1px); /*maybe deprecated but we need to support legacy browsers */
  clip-path: inset(50%); /*modern browsers, clip-path works inwards from each corner*/
  white-space: nowrap; /* added line to stop words getting smushed together (as they go onto seperate lines and some screen readers do not understand line feeds as a space */
`;
